<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <div class="search-wrap">
        <Form
          ref="formInline"
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
        >
          <Row class="relative" type="flex" flex="end">
            <FormItem class="sch-form-item" label="">
              <Input
                v-model="formValidate.planName"
                class="search-input-430"
                clearable
                placeholder="请输入课酬方案名称"
              ></Input>
            </FormItem>
            <FormItem class="sch-form-item" label="">
              <ChooseSchool
                ref="chooseSchoolRef"
                @on-change="onSchChange"
              ></ChooseSchool>
            </FormItem>
            <FormItem class="sch-form-item" label="">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择学期`"
                :need-init-data="false"
                :clearable="true"
                @on-change="onCascaderChange"
              ></CascaderYearTerms>
            </FormItem>
            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleSearch"
            >查询</Button>
            <Button @click="handleReset">重置</Button>
          </Row>
        </Form>
      </div>
      <div class="table-title-special-430 flex justify-content_end">
        <Button type="primary" @click="handleAdd">添加方案</Button>
      </div>
    </div>
    <div class="table-wrap">
      <Table
        :columns="columns"
        :data="tableList"
        :loading="loading"
        :max-height="tableHeight"
        border
      >
        <template slot="planName" slot-scope="{ row }">
          <TablePoptip :content="row.planName"> </TablePoptip>
        </template>
        <template slot="isCalLeave" slot-scope="{ row, index }">
          {{ +row.isCalLeave === 1 ? '请假学生计入教师工资' : '' }}
        </template>
        <template slot="schoolNum" slot-scope="{ row, index }">
          <span class="click-btn-430" @click="handleToShowSchoolList(row)">{{
            row.schoolNum
          }}</span>
        </template>
        <template slot="zaotuo" slot-scope="{ row, index }">
          <div v-if="row.zaotuo.length > 0" class="course-line">
            <div v-for="(x, y) in row.zaotuo" :key="y">{{ x }}</div>
          </div>
          <div v-else>--</div>
        </template>
        <template slot="wutuo" slot-scope="{ row, index }">
          <div v-if="row.wutuo.length > 0" class="course-line">
            <div v-for="(x, y) in row.wutuo" :key="y">{{ x }}</div>
          </div>
          <div v-else>--</div>
        </template>
        <template slot="wantuo" slot-scope="{ row, index }">
          <div v-if="row.wantuo.length > 0" class="course-line">
            <div v-for="(x, y) in row.wantuo" :key="y">{{ x }}</div>
          </div>
          <div v-else>--</div>
        </template>
        <template slot="wanxiu" slot-scope="{ row, index }">
          <div v-if="row.wanxiu.length > 0" class="course-line">
            <div v-for="(x, y) in row.wanxiu" :key="y">{{ x }}</div>
          </div>
          <div v-else>--</div>
        </template>
        <template slot="suzhi" slot-scope="{ row, index }">
          <div v-if="row.suzhi.length > 0" class="course-line">
            <div v-for="(x, y) in row.suzhi" :key="y">{{ x }}</div>
          </div>
          <div v-else>--</div>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <span
            class="click-btn-430"
            @click="handleToEdit(row.planId)"
          >编辑</span>
          <span
            class="click-btn-430"
            @click="handleToCopy(row.planId)"
          >复制</span>
          <span
            class="click-btn-430"
            @click="handleDelPlan(row.planId)"
          >删除</span>
          <span
            class="click-btn-430"
            @click="handleSetSchool(row.planId)"
          >配置适用学校</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="handlePage"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      title="适用学校"
      :footer-hide="true"
      :closable="true"
    >
      <Table
        :columns="columnSchool"
        :data="dataSchool"
        :loading="loadingSchool"
        border
      ></Table>
      <div class="page-wrap">
        <Page
          :total="pageInfoSchool.total"
          show-sizer
          show-elevator
          show-total
          class="text-right mb-5 mt-5"
          :current="pageInfoSchool.pageNum"
          :page-size="pageInfoSchool.pageSize"
          :page-size-opts="pageSizeSchoolOpts"
          @on-change="handlePageSchool"
          @on-page-size-change="handlePageSizeSchool"
        ></Page>
      </div>
    </Modal>
  </div>
</template>
<script>
import ChooseSchool from '@c/searchBlock/ChooseSchool';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import orderCenterApi from '@/request/orderCenter/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { mapMutations } from 'vuex';

import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
export default {
  name: 'TeacherSalarySettingList',
  components: {
    ChooseSchool,
    CascaderYearTerms
  },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('TeacherSalarySettingList');
    next();
  },
  data() {
    return {
      formValidate: {
        planName: '',
        schoolId: null,
        yearCode: null,
        termCode: null
      },
      pageSizeSchoolOpts: [10, 20, 50, 100],
      pageSizeOpts: [10, 20, 50, 100],
      pageInfoSchool: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        {
          title: '教师课酬方案名称',
          slot: 'planName',
          minWidth: tableColumnsWidth.type6,
          fixed: 'left'
        },
        {
          title: '学期',
          key: 'yearTerm',
          minWidth: tableColumnsWidth.type4,
          fixed: 'left'
        }, {
          title: '适用学校',
          slot: 'schoolNum',
          minWidth: 100,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '请假学生课酬计算设置',
          slot: 'isCalLeave',
          width: 180
        }, {
          title: '早托',
          slot: 'zaotuo',
          minWidth: 230
        }, {
          title: '午托',
          slot: 'wutuo',
          minWidth: 230
        }, {
          title: '晚托',
          slot: 'wantuo',
          minWidth: 230
        }, {
          title: '晚修',
          slot: 'wanxiu',
          minWidth: 230
        }, {
          title: '素质课程',
          slot: 'suzhi',
          minWidth: 230
        }, {
          title: '最近更新时间',
          key: 'operateTime',
          minWidth: 190
        }, {
          title: '最近更新人',
          key: 'operatorName',
          minWidth: 130,
          align: 'center'
        }, {
          title: '操作',
          slot: 'action',
          minWidth: 230,
          fixed: 'right'
        }
      ],
      tableList: [],
      loading: false,
      modalShow: false,
      columnSchool: [
        {
          title: '序号',
          key: 'orderNO',
          minWidth: 50
        }, {
          title: '学校名称',
          key: 'schoolName',
          minWidth: 200
        }, {
          title: '教师课酬方案名称',
          key: 'planName',
          minWidth: 200
        }
      ],
      dataSchool: [],
      loadingSchool: false,
      selectRow: {}
    };
  },
  created() {
    this.getCoursefeeAllotPlansList();
  },
  activated() {
    this.getCoursefeeAllotPlansList();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 获取课酬方案列表
    async getCoursefeeAllotPlansList() {
      const { total, ...pageInfo } = this.pageInfo;
      const { planName, ...otherFormValidate } = this.formValidate;
      const params = {
        ...otherFormValidate,
        ...pageInfo
      };
      planName ? params.planName = planName : '';
      params.schoolId && +params.schoolId === -1 ? params.schoolId = null : '';
      this.loading = true;
      const res = await orderCenterApi.getCoursefeeAllotPlansApi(params);
      this.loading = false;
      if (res.status === 200 && res.message) {
        this.tableList = res.message.list.map(item => {
          item.zaotuo = [];
          item.wutuo = [];
          item.wantuo = [];
          item.wanxiu = [];
          item.suzhi = [];
          item.coursefeeAllotPlanItemInfoDtoList.forEach(x => {
            const list = x.allotPlanItemInfoDtoList.map(j => {
              if (+j.stuMax !== 99999) {
                return `${j.stuMin}-${j.stuMax}人：课酬${j.onceFee / 100}元/${+x.calType === 1 ? '节课' : '学生'}`;
              } else {
                return `${j.stuMin}人以上：课酬${j.onceFee / 100}元/${+x.calType === 1 ? '节课' : '学生'}`;
              }
            });
            switch (+x.courseType) {
              case 1:
                item.suzhi = list;
                break;
              case 2:
                item.wutuo = list;
                break;
              case 3:
                item.wantuo = list;
                break;
              case 4:
                item.wanxiu = list;
                break;
              case 5:
                item.zaotuo = list;
                break;
              default:
                break;
            }
          });
          return item;
        });
        this.pageInfo.total = +res.message.total;
      } else if (res.status === 200) {
        this.tableList = [];
        this.pageInfo.total = 0;
      }
    },
    onSchChange(sch) {
      this.formValidate.schoolId = sch.schoolId;
    },
    async handleSearch() {
      this.pageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.tableList = [];
      this.getCoursefeeAllotPlansList();
    },
    handleToEdit(planId) {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_teacherSalarySettingEdit',
        query: {
          planId
        }
      });
    },
    handleToCopy(planId) {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_teacherSalarySettingEdit',
        query: {
          planId,
          isCopy: 1
        }
      });
    },
    // 删除方案
    handleDelPlan(planId) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除吗？删除后不可恢复',
        onOk: () => {
          this.delPlanTrue(planId);
        }
      });
    },
    // 配置适用学校
    handleSetSchool(planId) {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_relSchoolSetting',
        query: {
          planId,
          isSet: 1
        }
      });
    },
    async delPlanTrue(planId) {
      const params = {
        planId
      };
      const res = await orderCenterApi.deleteCoursefeeAllotPlanApi(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        this.getCoursefeeAllotPlansList();
      }
    },
    handleReset() {
      this.$refs.chooseSchoolRef &&
        this.$refs.chooseSchoolRef.handleClear();
      this.$refs.cascaderYearTerms &&
        this.$refs.cascaderYearTerms.handleClear();
      this.formValidate = {
        schoolId: null,
        yearCode: null,
        termCode: null
      };
      this.handleSearch();
    },
    handleAdd() {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_teacherSalarySettingAdd'
      });
    },
    onCascaderChange(v) {
      console.log(v, '年度资源学期');
      this.formValidate.yearCode = v[0];
      this.formValidate.termCode = v[1];
    },
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getCoursefeeAllotPlansList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getCoursefeeAllotPlansList();
    },
    handleToShowSchoolList(row) {
      if (row.schoolNum < 1) {
        return;
      }
      this.dataSchool = [];
      this.selectRow = row;
      this.getSchoolList(row.planId, row.planName);
      this.modalShow = true;
    },
    handlePageSchool(page) {
      this.pageInfoSchool.pageNum = page;
      this.getSchoolList(this.selectRow.planId, this.selectRow.planName);
    },
    handlePageSizeSchool(pageSize) {
      this.pageInfoSchool.pageSize = pageSize;
      this.pageInfoSchool.pageNum === 1 && this.getSchoolList(this.selectRow.planId, this.selectRow.planName);
    },
    // 获取适用学校列表
    async getSchoolList(planId, planName) {
      const params = {
        planId,
        pageNum: this.pageInfoSchool.pageNum,
        pageSize: this.pageInfoSchool.pageSize
      };
      this.loadingSchool = true;
      const res = await orderCenterApi.getListSchRelPlanApi(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        res.message.list = res.message.list ? res.message.list : [];
        this.dataSchool = res.message.list.map((item, index) => {
          item.orderNO = index + 1 + (params.pageSize * (params.pageNum - 1));
          item.planName = planName;
          return item;
        });
        this.pageInfoSchool.total = +res.message.total;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-wrap {
  padding: 16px 0;
  text-align: right;
}
.btn-line {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}
.course-line {
  & > div {
    line-height: 30px;
  }
}
.search-input {
  width: 160px;
  margin-right: 16px;
}
</style>
